import { useEffect, useState, useRef, useCallback } from 'react';
import * as React from 'react';
import { GoogleMap, Marker, MarkerF, useJsApiLoader, InfoWindow, OverlayView } from '@react-google-maps/api';
import { Paper } from '@mui/material';
import LeadService from '../../../core/services/leadsService';
import toast from 'react-hot-toast';
import Button from '@mui/material/Button';
import AgentProfile from '../AgentProfile/AgentProfile';
import CustomerLeadProfile from '../CustomerLeadProfile/CustomerLeadProfile';
import { useNavigate } from 'react-router-dom';
import FormControl from '@mui/material/FormControl';
import Brightness1OutlinedIcon from '@mui/icons-material/Brightness1Outlined';
import Convrt_bg_blue from '../../../../public/assets/Convrt_bg_blue.png';
import ExpandLessIcon from '@mui/icons-material/ExpandLess';
import { debounce, throttle } from 'lodash';
import {
    Typography,
    Box,
    Accordion,
    AccordionSummary,
    AccordionDetails,
    TextField,
    Menu,
    Autocomplete,
    LinearProgress,
    Dialog,
    DialogActions,
    DialogContent,
    DialogContentText,
    DialogTitle,
    Card,
    Grid,
    CircularProgress,
    ListItemText,
    ListItem,
    List,
} from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';
import Checkbox from '@mui/material/Checkbox';
import FormControlLabel from '@mui/material/FormControlLabel';
import { IconButton } from '@mui/material';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import Slide from '@mui/material/Slide';
import Avatar from '@mui/material/Avatar';
import MenuItem from '@mui/material/MenuItem';
import LogoutExpiredModal from '../../LogoutExpiredModal';
import FiberManualRecordIcon from '@mui/icons-material/FiberManualRecord';
import { useDateTime } from '../../../pages/ContextDateandTime/DateTimeContext';
import { useDispatch, useSelector } from 'react-redux';
import { CLOSE_INVITE_MODEL } from '../../../core/store/slice/icaSlice';
import InviteAgent from './InviteAgent';
import SearchIcon from '@mui/icons-material/Search';
import InputBase from '@mui/material/InputBase';
import CachedIcon from '@mui/icons-material/Cached';
import { makeStyles } from '@mui/styles';
import { useTheme } from '@mui/material/styles';
const useStyles = makeStyles((theme) => ({
    mapInviteButtonStyle: {
        position: 'absolute',
        top: '15px',
        left: '87%',
        transform: 'translateX(-50%)',
        zIndex: 10,
        display: 'flex',
        alignItems: 'center',
        borderRadius: '4px',
        padding: '5px',
        [theme.breakpoints.down('md')]: {
            position: 'absolute',
            top: '15px',
            left: '84%',
            transform: 'translateX(-50%)',
            zIndex: 10,
            display: 'flex',
            alignItems: 'center',
            borderRadius: '4px',
            padding: '5px',
        },
    },

    mapReloadButtonStyle: {
        position: 'absolute',
        top: '15px',
        left: '97%',
        transform: 'translateX(-50%)',
        zIndex: 10,
        display: 'flex',
        alignItems: 'center',
        borderRadius: '4px',
        padding: '5px',
        [theme.breakpoints.down('md')]: {
            position: 'absolute',
            top: '15px',
            left: '95%',
            transform: 'translateX(-50%)',
            zIndex: 10,
            display: 'flex',
            alignItems: 'center',
            borderRadius: '4px',
            padding: '5px',
        },
    },
}));
const Transition = React.forwardRef(function Transition(props, ref) {
    return <Slide direction="up" ref={ref} {...props} />;
});
const containerStyle = {
    width: 'auto',
    height: 'calc(96vh - 65px)',
    position: 'relative',
    borderRadius: '6px',
};

const center = {
    lat: 34.0536909,
    lng: -118.242766,
};

function MyComponent() {
    const { isLoaded } = useJsApiLoader({
        id: 'google-map-script',
        googleMapsApiKey: 'AIzaSyC9saN_UXZFij-RjWWX9drQEQSZw5PaPcA',
    });
    const navigate = useNavigate();
    const [map, setMap] = React.useState(null);
    const [agents, setAgents] = React.useState([]);
    const [AllAgentsData, setAllAgentsData] = React.useState([]);
    const [searchValue, setSearchValue] = React.useState('new');
    const [properties, setProperties] = React.useState([]);
    const [loading, setLoading] = useState(false);
    const [ModalOpenLoading, setModalOpenLoading] = useState(false);
    const [assignUserLoading, setAssignUserLoading] = useState(false);
    const { selectedDate, selectTime, setSelectedDate, setSelectTime } = useDateTime();
    const [mapCenter, setMapCenter] = React.useState({ lat: 34.052235, lng: -118.243683 });
    const [zoom, setZoom] = React.useState(8);
    const mapRef = React.useRef(null);
    const [selectedAgent, setSelectedAgent] = React.useState(null);
    const [selectedProperties, setSelectedProperties] = React.useState(null);
    const [selectedPropertyId, setSelectedPropertyId] = React.useState(null);
    const [AssignAgentData, setAssignAgentData] = React.useState('');
    const [markerIconUrl, setMarkerIconUrl] = React.useState('/assets/BlackAgent.png');
    const [open, setOpen] = React.useState(false);
    const [logOutModal, setLogOutModal] = React.useState(false);
    const [googleLocation, setGoogleLocation] = useState(null);
    const [longitude, setLongitude] = useState(null);
    const [latitude, setLatitude] = useState(null);
    const [PreferredRegions, setPreferredRegions] = useState([null]);
    const [anchorEl, setMenuOpen] = useState(null);
    const [searchTerm, setSearchTerm] = useState('');
    const [expanded, setExpanded] = useState(false);
    const [selectedPropertiesPopUP, setSelectedPropertiesPopUP] = useState(null);
    const [selectedAgentProfile, setSelectedAgentProfile] = useState(null);
    const [selectedRegion, setSelectedRegion] = useState(null);
    const [OpenSelectAgent, setOpenSelectAgent] = useState(false);
    const [selectedAgentsCheckId, setSelectedAgentsCheckId] = useState('');
    const [searchTermAgent, setSearchTermAgent] = useState('');
    const [selectedOption, setSelectedOption] = useState(null);
    const [openAgentView, setOpenAgentView] = useState(false);
    const [selectedTags, setSelectedTags] = useState([]);
    const [tags, setTags] = useState([]);
    const [openGroups, setOpenGroups] = useState({});
    const [filterText, setFilterText] = useState('');
    const [userToggles, setUserToggles] = useState({});
    const abortControllerRef = useRef(null);
    const pollRef = useRef(null);

    const classes = useStyles();
    const theme = useTheme();

    const handleAgentViewOpen = () => {
        setOpenAgentView(true);
    };

    const handleAgentViewClose = () => {
        setOpenAgentView(false);
    };

    const handleClick = (event) => {
        // Toggle the menu when the button is clicked
        if (anchorEl) {
            handleCloseMenu();
        } else {
            setMenuOpen(event.currentTarget);
        }
    };

    const handleCloseMenu = () => {
        setMenuOpen(null);
    };

    const handleAccordionChange = (panel) => (event, isExpanded) => {
        setExpanded(isExpanded ? panel : false);
    };

    const handleSearchChange = (e) => {
        setSearchTerm(e.target.value.toLowerCase());
    };

    const MenuOpen = Boolean(anchorEl);

    const IcaMapStatus = [
        { label: 'New', value: 'new' },
        { label: 'Assigned', value: 'assign_leads' },
        { label: 'Invitation Sent', value: 'invitation_sent' },
        { label: 'Assign By Me', value: 'assign_by_me' },
        { label: 'Appointment Set', value: 'appointment_set' },
        { label: 'Spoke with Customer', value: 'spoke_with_customer' },
        { label: 'Showing Homes', value: 'showing_homes' },
        { label: 'Submitting Offers', value: 'submitting_offers' },
        { label: 'Met with Customer', value: 'met_with_customer' },
        { label: 'Under Contract', value: 'under_contract_escrow' },
        { label: 'BAMFAM', value: 'bamfam' },
        { label: 'Nurture Before Sale', value: 'nurture' },
        { label: 'Sale Closed', value: 'closed' },
        { label: 'Nurture After Sale', value: 'nurture_after_sale' },
        { label: 'Rejected', value: 'rejected' },
        { label: 'Follow Up', value: 'follow_up' },
        { label: 'Buy Side Contract', value: 'buy_side_contract' },
        { label: 'List Under Contract', value: 'list_under_contract' },
        { label: 'Listing Signed', value: 'listing_signed' },
        { label: 'Listing Appointment', value: 'listing_appointment' },
        { label: 'Valuation Appointment', value: 'valuation_appointment' },
        { label: 'Buyer Broker Signed', value: 'buyer_broker_signed' },
        { label: 'DNC', value: 'dnc' },
        { label: 'Agent', value: 'agent' },
        { label: 'Not Interested', value: 'not_interested' },
        { label: 'Personal Lead', value: 'personal_lead' },
        { label: 'Active Listing', value: 'active_listing' },
        { label: 'Listing Agreement', value: 'listing_agreement' },
    ];

    const colorMap = {
        active: '#8c8c8c',
        new: '#8c8c8c',
        attempting_contact: '#6d6dd0',
        spoke_with_customer_new: '#6d6dd0',
        spoke_with_customer: '#5f9b7d',
        appointment_set: '#5f9b7d',
        met_with_customer: '#7b57a9',
        showing_homes: '#b37b92',
        submitting_offers: '#639e78',
        under_contract_escrow: '#5a589f',
        bamfam: '#9a9cb5',
        nurture: '#a37b56',
        nurture_after_sale: '#a77a08',
        closed: '#cc8756',
        rejected: '#bb606a',
        not_interested: '#a1234a',
        refinance_referral: '#9b9467',
        agent: '#4a0098',
        personal_lead: '#999999',
        bad_lead: '#7f1f06',
        buy_side_contract: '#a77a08',
        dnc: '#7930c7',
        buyer_broker_signed: '#b2617a',
        cancelled: '#352c70',
        valuation_appointment: '#5c7000',
        listing_signed: '#8f6b00',
        listing_appointment: '#872f18',
        follow_up: '#1d5940',
    };

    const selectedColor = colorMap[IcaMapStatus.find((option) => option.value === searchValue)?.value] || 'black';

    const MarkerWithLabel = ({ label }) => (
        <div style={{ position: 'relative', top: '-20px', left: '-10px', width: 'fit-content' }}>
            <div style={{ backgroundColor: 'white', padding: '5px', borderRadius: '5px', boxShadow: '0 2px 4px rgba(0, 0, 0, 0.3)' }}>{label}</div>
        </div>
    );

    const onLoad = React.useCallback(function callback(map) {
        // This is just an example of getting and using the map instance!!! don't just blindly copy!
        const bounds = new window.google.maps.LatLngBounds(center);
        map.fitBounds(bounds);

        setMap(map);
    }, []);

    const icaStore = useSelector((state) => state.ica);

    useEffect(() => {
        if (icaStore.locationModal.open) {
            setSelectedProperties(icaStore.locationModal.leadDetails);
            setProperties([icaStore.locationModal.leadDetails]);
        }
    }, [icaStore.locationModal.open]);

    useEffect(() => {
        if (icaStore.leadModal.open) {
            setSelectedProperties(icaStore.leadModal.id.lead);
            // setProperties([icaStore.locationModal.id]);
        }
    }, [icaStore.leadModal.open]);

    const onUnmount = React.useCallback(function callback(map) {
        setMap(null);
    }, []);

    const HandleRestValue = async () => {
        if (searchValue !== 'new') {
            stopGetLeads(); // Stop the ongoing API call
        }
        setSelectedOption(null);
        setSelectedAgentProfile(null);
        setSelectTime('');
        setSelectedDate('');
        setSelectedAgent(null);
        setSelectedTags([]);
        setTags([]);
        setSearchValue('new');
        setTimeout(() => {
            getLeads('new');
        }, 0);
    };

    // const getLeads = async (searchValue) => {
    //     try {
    //         setLoading(true);
    //         const res = await LeadService.getLeads(searchValue);
    //         if (res?.data?.success) {
    //             setProperties(res?.data?.properties?.data);
    //             setAgents(res?.data['agents']);
    //             setSelectTime('');
    //             setSelectedDate('');
    //             setSelectedAgentsCheckId('');
    //             return;
    //         }
    //     } catch (error) {
    //         console.error(error.message);
    //         if (error.message === 'You have been logged out of the application, please login again to use the application.') {
    //             setLogOutModal(true);
    //         } else {
    //             toast.error(error.message);
    //         }
    //     } finally {
    //         setLoading(false);
    //     }
    // };

    // useEffect(() => {
    //     if (!icaStore.locationModal.open) getLeads(searchValue);
    // }, [searchValue]);

    const getLeads = async (searchValue, isPolling = false) => {
        try {
            if (searchValue === 'new' && !isPolling) {
                setLoading(true);
            }

            // Abort previous request if a new one is initiated
            if (!isPolling) {
                if (abortControllerRef.current) {
                    abortControllerRef.current.abort();
                }
                abortControllerRef.current = new AbortController();
            }
            const signal = abortControllerRef.current.signal;

            let currentPage = 1;
            let hasMorePages = true;

            while (hasMorePages) {
                if (signal.aborted) {
                    console.log('Request aborted');
                    return;
                }
                const res = await LeadService.getLeads(searchValue, currentPage, { signal });

                if (res?.data?.success) {
                    const { data: propertiesData = [], current_page, last_page } = res?.data?.properties || {};
                    const agentsData = res?.data?.agents || [];

                    setProperties((prevProperties) => {
                        const uniqueProperties = new Set(prevProperties.map((prop) => prop.id));
                        const filteredProperties = propertiesData.filter((prop) => !uniqueProperties.has(prop.id));

                        return filteredProperties.length > 0 ? [...prevProperties, ...filteredProperties] : prevProperties;
                    });

                    setAgents((prevAgents) => {
                        const uniqueAgents = new Set(prevAgents.map((agent) => agent.id));
                        const filteredAgents = agentsData.filter((agent) => !uniqueAgents.has(agent.id));

                        return filteredAgents.length > 0 ? [...prevAgents, ...filteredAgents] : prevAgents;
                    });

                    currentPage = current_page + 1;
                    hasMorePages = currentPage <= last_page;

                    if (hasMorePages && !signal.aborted) {
                        await new Promise((resolve) => setTimeout(resolve, 5000)); // Wait 5s before fetching the next page
                    }

                    setSelectTime('');
                    setSelectedDate('');
                    setSelectedAgentsCheckId('');
                } else {
                    throw new Error('Failed to fetch data.');
                }
            }

            // Start polling every 10s after all pages are completed
            if (!isPolling && !signal.aborted) {
                if (pollRef.current) {
                    clearInterval(pollRef.current);
                }
                pollRef.current = setInterval(() => {
                    getLeads(searchValue, true);
                }, 15000);
            }
        } catch (error) {
            if (signal.aborted) {
                console.log('API request aborted');
            } else {
                console.error(error.message);
                if (error.message === 'You have been logged out of the application, please login again to use the application.') {
                    setLogOutModal(true);
                } else {
                    toast.error(error.message);
                }
            }
        } finally {
            if (!isPolling) {
                setLoading(false);
            }
        }
    };
    

    useEffect(() => {
    let delayTimer;

    const fetchLeads = async () => {
        setAgents([]);
        setProperties([]);
        await getLeads(searchValue);
    };

    if (searchValue) {
        delayTimer = setTimeout(fetchLeads, 5000); 
    }
        
    return () => {
        clearTimeout(delayTimer); 
        if (abortControllerRef.current) {
            abortControllerRef.current.abort();
        }
        if (pollRef.current) {
            clearInterval(pollRef.current);
        }
    }; 
    }, [searchValue]);

    // StopIt Function (Stop Ongoing API Calls)
    const stopGetLeads = () => {
        if (abortControllerRef.current) {
            abortControllerRef.current.abort();
            console.log('API call stopped');
        }
        if (pollRef.current) {
            clearInterval(pollRef.current);
            pollRef.current = null;
            console.log('Polling stopped');
        }
    };
   
    const handleMoveToFilter =  (event, newValue) => {
        setSearchValue(newValue ? newValue?.value : '');
        setMapCenter({ lat: 34.052235, lng: -118.243683 });
        setSelectedOption(null);
        setAgents((prevAgents) => (prevAgents.length > 0 ? [] :  [] ));
        setProperties((prevProperties) => (prevProperties.length > 0 ? [] :  [] ));
        setZoom(10);
        if (mapRef.current) {
            mapRef.current.panTo({ lat: 34.052235, lng: -118.243683 });
            mapRef.current.setZoom(10);
        }
    };

    
    useEffect(() => {
        if (properties?.length > 0) {
            // Set the map center to the first property's coordinates if properties data is available
            setMapCenter({
                lat: parseFloat(properties[0].buyer_latitude),
                lng: parseFloat(properties[0].buyer_longitude),
            });
        }
    }, [properties]);

  


    // useEffect(() => {
    //     if (agents?.length > 0) {
    //         setMapCenter({
    //             lat: parseFloat(agents[0]?.latitude),
    //             lng: parseFloat(agents[0]?.longitude),
    //         });
    //     }
    // }, [agents]);
    useEffect(() => {
        if (agents?.length > 0) {
            setMapCenter({
                lat: 34.052235,
                lng: -118.243683,
            });
        }
    }, [agents]);

    const infoWindowStyles = {
        padding: '10px',
        borderRadius: '8px',
        backgroundColor: '#fff',
        width: '50px',
        height: '10px',
        boxShadow: '0 2px 4px rgba(0,0,0,0.2)',
    };

    const infoWindowContentStyles = {
        fontSize: '8px',
        fontWeight: 'bold',
    };
    const [selectedAgents, setSelectedAgents] = useState({});

    const handleMarkerClick = (agent) => {
        if (properties?.length === 1) {
            // Toggle the selected state for this specific agent
            setSelectedAgents((prevSelectedAgents) => ({
                ...prevSelectedAgents,
                [agent.id]: !prevSelectedAgents[agent.id], // Toggle selection for this agent
            }));
            const assignAgentDataIds = AssignAgentData.split(',').map((id) => parseInt(id));
            if (assignAgentDataIds.includes(agent.id)) {
                // Remove agent ID if already selected
                const updatedAssignAgentData = assignAgentDataIds.filter((id) => id !== agent.id).join(',');
                setAssignAgentData(updatedAssignAgentData);
                toast.success(`Agent ${agent.name} is removed`, {
                    style: {
                        border: '1px solid #713200',
                        padding: '16px',
                        color: '#713200',
                    },
                    iconTheme: {
                        primary: '#713200',
                        secondary: '#FFFAEE',
                    },
                });
            } else {
                // Add agent ID if not selected
                setAssignAgentData((prevData) => (prevData ? prevData + ',' : '') + agent.id);
                toast(`New agent ${agent.name} is added\n📊 Quota: ${agent?.quota}\n🎯 Score: ${agent?.score}`);
            }
        }
        setSelectedAgent(agent);
    };

    const handleAgentProfileClick = (agent) => {
        setSelectedAgentProfile(agent);
        setSelectedPropertiesPopUP(null);
        setSelectedRegion(null);
    };

    React.useEffect(() => {
        if (AssignAgentData && properties?.length === 1) {
            const assignAgentDataIds = AssignAgentData.split(',').map((id) => parseInt(id));
            if (assignAgentDataIds.includes(selectedAgent?.id)) {
                setMarkerIconUrl('/assets/man-avatar.png');
            } else {
                setMarkerIconUrl('/assets/BlackAgent.png');
            }
        }
    }, [AssignAgentData, properties, selectedAgent]);

    const handleCloseModal = () => {
        setSelectedAgent(null);
    };
    const handleMarkerClickProperties = (property) => {
        setSelectedPropertiesPopUP(property);
        setSelectedAgentProfile(null);
        setSelectedRegion(null);
    };
    const handleProfileClick = (selectedPropertiesPopUP) => {
        if (selectedProperties === selectedPropertiesPopUP) {
            setSelectedProperties(null);
        } else {
            setSelectedProperties(selectedPropertiesPopUP);
        }
    };

    const handleCloseModalProperties = () => {
        setSelectedProperties(null);
    };
    const handleClose = async () => {
        setAssignAgentData('');
        setOpen(false);
        // setSearchValue('');
        await getLeads(searchValue);
    };
    const handleAssignLead = async (
        selectedLocation,
        selectedPropertiesId,
        selectTime,
        selectedDate,
        googleLocation,
        latitude,
        longitude,
        selectedTags
    ) => {
        try {
            const formattedTags = Array.isArray(selectedTags) ? selectedTags.join(',') : selectedTags;
            setModalOpenLoading(true);
            const time = new Date(selectTime);
            const formattedSelectTime = `${String(time.getHours()).padStart(2, '0')}:${String(time.getMinutes()).padStart(2, '0')}:${String(time.getSeconds()).padStart(2, '0')}`;
            let radius = '75';
            const res = await LeadService.nearestAgents(
                selectedLocation,
                selectedPropertiesId,
                formattedSelectTime,
                selectedDate,
                radius,
                formattedTags
            );
            if (res?.data?.success === true) {
                setAssignUserLoading(true);
                const idToPass = selectedPropertiesId;
                const matchingProperty = properties.find((property) => property.id === idToPass);
                if (matchingProperty) {
                    setProperties(null);
                    setProperties([matchingProperty]);
                }
                setAgents([]);
                setAgents(res?.data?.nearest_agents);
                toast.success(res?.data?.message);
                toast.success('Please select atleast one agents, or refresh  to cancel');
                setSelectedProperties(null);
                setSelectedAgents({});
                await setSelectedPropertyId(selectedPropertiesId);
                await setGoogleLocation(googleLocation);
                await setLatitude(latitude);
                await setLongitude(longitude);

                return;
            } else {
                toast.error(res.message);
            }
        } catch (error) {
            console.error(error);
            toast.error(error.message);
            setSelectedProperties(null);
        } finally {
            setModalOpenLoading(false);
            setAssignUserLoading(false);
        }
    };

    const dispatch = useDispatch();

    useEffect(() => {
        stopGetLeads();
        if (icaStore.invitedAgentModal.open) {
            setOpen(true);
            setSelectedPropertyId(icaStore.invitedAgentModal.id);
            GetAllInviteAgents(icaStore.invitedAgentModal.id, icaStore.invitedAgentModal.id)
                .then(() => { })
                .catch(() => { });
        }
    }, [icaStore.invitedAgentModal?.open]);

    const AssignUser = async (AssignAgentData, selectedPropertyId, selectedDate, selectTime, googleLocation, latitude, longitude) => {
        try {
            if (!AssignAgentData) {
                toast.error('Please assign at least one agent');
                return;
            } else {
                setModalOpenLoading(true);
                const time = new Date(selectTime);
                const formattedSelectTime = `${String(time.getHours()).padStart(2, '0')}:${String(time.getMinutes()).padStart(2, '0')}:${String(time.getSeconds()).padStart(2, '0')}`;
                const res = await LeadService.AssignLeadsToAgents(
                    AssignAgentData,
                    selectedPropertyId,
                    selectedDate,
                    formattedSelectTime,
                    googleLocation,
                    latitude,
                    longitude
                );
                if (res?.data?.success) {
                    toast.success(res?.data.message);
                    setSelectedDate('');
                    setSelectTime('');
                    setTags([]);
                    setSelectedTags([]);
                    // await getLeads(searchValue);
                    setSelectedOption(null);
                    setSelectedAgent(null);
                    setGoogleLocation(null);
                    setLatitude(null);
                    setLongitude(null);
                    setAssignAgentData('');
                    setOpenSelectAgent(false);
                    setOpen(true);
                    await GetAllInviteAgents(selectedPropertyId);
                    setSelectedAgentsCheckId('');
                    return;
                }
            }
        } catch (error) {
            console.error(error);
            toast.error(error.message);
        } finally {
            setModalOpenLoading(false);
        }
    };

    let showExpirationToast = true;
    const [AllAgentsLeadData, setAllAgentsLeadData] = useState({});
    const GetAllInviteAgents = async (selectedPropertyId, id) => {
        try {
            const fetchAgentsData = async () => {
                dispatch(CLOSE_INVITE_MODEL());
                const res = await LeadService.AgentInvite(selectedPropertyId || id);
                if (res?.data?.success === true) {
                    setAllAgentsData(res?.data?.data);
                    setAllAgentsLeadData(res?.data?.data[0]);
                } else if (res.data.success === false) {
                    setAllAgentsData(res?.data?.data);
                    if (showExpirationToast) {
                        toast.success('Invitation request time has expired');
                    }
                    // setTimeout(() => setOpen(false), 5000);
                    clearInterval(intervalId);
                    return;
                }
            };
            await fetchAgentsData();
            const intervalId = setInterval(fetchAgentsData, 15000);
            return () => clearInterval(intervalId);
        } catch (error) {
            console.error(error);
            toast.error(error.message);
        }
    };

    const handleRequestedAgents = async (selectedPropertyId) => {
        setOpen(true);
        await GetAllInviteAgents(selectedPropertyId);
    };

    const getPreferredRegions = async () => {
        try {
            const res = await LeadService.getPreferedRegions();
            if (res?.data?.success === true) {
                setPreferredRegions(res?.data?.data);
                return;
            }
        } catch (error) {
            console.error(error);
            toast.error(error?.message);
        }
    };

    useEffect(() => {
        getPreferredRegions();
    }, []);
    const handleCloseSelectAgent = () => {
        setOpenSelectAgent(false);
        setSelectedAgentsCheckId('');
    };
    const handleDoneSelectAgent = () => {
        if (!selectedAgentsCheckId) {
            toast.error('Please select at least one agent');
            return;
        } else {
            setOpenSelectAgent(false);
        }
    };
    const handleOpenSelectAgent = () => {
        setOpenSelectAgent(true);
    };

    const handleCheckboxChange = (agentId) => {
        setSelectedAgentsCheckId((prevSelected) => {
            const currentIds = prevSelected ? prevSelected.split(',') : [];
            if (currentIds.includes(agentId.toString())) {
                return currentIds.filter((id) => id !== agentId.toString()).join(',');
            } else {
                return [...currentIds, agentId.toString()].join(',');
            }
        });
    };

    const handleSelectAll = () => {
        if (selectedAgentsCheckId.split(',').length === agents?.length) {
            setSelectedAgentsCheckId(''); // Unselect all
        } else {
            const allAgentIds = agents.map((agent) => agent?.id).join(','); // Join all IDs into a string
            setSelectedAgentsCheckId(allAgentIds); // Set all IDs as a string
        }
    };

    const filteredAgentsChecked = agents?.filter((agent) =>
        `${agent?.name} ${agent?.last_name}`.toLowerCase().includes(searchTermAgent.toLowerCase())
    );

    const customSort = (a, b) => {
        const order = { REGIONS: 1, AGENTS: 2, LEADS: 3 };
        return order[a.firstLetter] - order[b.firstLetter];
    };

    const mapStatusToFormatAndColorShow = (status) => {
        const statusMapping = {
            active: { text: ' ● New ', color: '#00000F' },
            new: { text: ' ● New ', color: '#00000F' },
            attempting_contact: { text: ' ● Attempting Contact ', color: '#9B0000' },
            spoke_with_customer_new: { text: ' ● New ', color: '#00000F' },
            spoke_with_customer: { text: ' ● Spoke with customer ', color: '#00BF2A' },
            appointment_set: { text: ' ● Appointment Set ', color: '#00BF2A' },
            met_with_customer: { text: ' ● Met with customer ', color: '#7400C2' },
            showing_homes: { text: ' ● Showing Homes ', color: '#ED7DB1' },
            submitting_offers: { text: ' ● Submitting Offers ', color: '#6EA478' },
            under_contract_escrow: { text: ' ● Under Contract/Escrow ', color: '#4C489B' },
            bamfam: { text: ' ● BAMFAM ', color: '#6691CB' },
            nurture: { text: ' ● Nurture Before sale ', color: '#9B5B00' },
            nurture_after_sale: { text: ' ● Nurture After Sale ', color: '#9B5B5B' },
            closed: { text: ' ●  Sale Closed ', color: '#F17105' },
            rejected: { text: ' ● Rejected ', color: '#ED0423' },
            not_interested: { text: ' ● Not Interested ', color: '#ebc3c3' },
            refinance_referral: { text: ' ● Refinance Referral ', color: '#9B5B5B' },
            personal_lead: { text: ' ● Personal Lead ', color: '#9B5B5B' },
            agent: { text: ' ● Agent ', color: 'white' },
            bad_lead: { text: ' ● Bad Lead ', color: '#2e1414' },
            buy_side_contract: { text: ' ● Buy Side Contract ', color: '#9B5B5B' },
            dnc: { text: ' ● DNC ', color: '#9B5B5B' },
            follow_up: { text: ' ● Follow Up ', color: '#FFFFFF' },
            buyer_broker_signed: { text: ' ● Buyer Broker Signed ', color: '#FFFFFF' },
            cancelled: { text: ' ● Cancelled ', color: '#FFFFFF' },
            valuation_appointment: { text: ' ● Valuation Appointment ', color: '#FFFFFF' },
            listing_signed: { text: ' ● Listing Signed ', color: '#FFFFFF' },
            listing_appointment: { text: ' ● Listing Appointment ', color: '#FFFFFF' },
        };
        const divBackgroundColors = {
            active: '#e9e4e4',
            new: '#e9e4e4',
            attempting_contact: '#ababef',
            spoke_with_customer_new: '#ababef',
            spoke_with_customer: '#bee5c6',
            appointment_set: '#bee5c6',
            met_with_customer: '#d9c2e9',
            showing_homes: '#f9d5e6',
            submitting_offers: '#bbe3c2',
            under_contract_escrow: '#c1bfed',
            bamfam: '#edeff5',
            nurture: '#f9deb8',
            nurture_after_sale: '#e7c612',
            closed: '#fff0e3',
            rejected: '#fbdfe2',
            not_interested: '#df3271',
            refinance_referral: '#e7e2c7',
            agent: '#5500CC',
            personal_lead: '##fff',
            bad_lead: '#c12f0d',
            buy_side_contract: '#e7c612',
            dnc: '#A87BFF',
            follow_up: '#469990',
            buyer_broker_signed: '#FABED4',
            cancelled: '#4C489B',
            valuation_appointment: '#7D9B00',
            listing_signed: '#C29800',
            listing_appointment: '#CB5935',
        };
        const divBorder = {
            active: '1px solid black',
            new: '1px solid black',
            attempting_contact: '1px solid #9B0000',
            spoke_with_customer_new: '1px solid #00000F',
            spoke_with_customer: '1px solid #00BF2A',
            appointment_set: '1px solid #00BF2A',
            met_with_customer: '1px solid #7400C2',
            showing_homes: '1px solid #ED7DB1',
            submitting_offers: '1px solid #6EA478',
            under_contract_escrow: '1px solid #4C489B',
            bamfam: '1px solid #6691CB',
            nurture: '1px solid #9B5B00',
            nurture_after_sale: '1px solid #9B5B5B',
            closed: '1px solid #F17105',
            rejected: '1px solid #ED0423',
            not_interested: '1px solid #a9199f',
            refinance_referral: '1px solid #a99497',
            agent: '1px solid #5500CC',
            personal_lead: '1px solid #a99497',
            bad_lead: '1px solid #5c433b',
            buy_side_contract: '1px solid #9B5B5B',
            dnc: '1px solid #9B5B5B',
            follow_up: '1px solid #469990',
            buyer_broker_signed: '1px solid #FABED4',
            cancelled: '1px solid #4C489B',
            valuation_appointment: '1px solid #7D9B00',
            listing_signed: '1px solid #483c10',
            listing_appointment: '1px solid #CB5935',
        };

        const { text, color } = statusMapping[status] || { text: status, color: '#000000' };
        const divBackgroundColor = divBackgroundColors[status] || 'transparent';
        const border = divBorder[status] || '1px solid black';
        return {
            formattedStatusShow: <span style={{ color }}>{text}</span>,
            divStyle: {
                background: divBackgroundColor,
                border,
            },
        };
    };
    const { formattedStatusShow, divStyle } = mapStatusToFormatAndColorShow(properties?.status);

    useEffect(() => {
        if (selectedAgentProfile) {
            setSelectedOption({
                title: `${selectedAgentProfile.name} ${selectedAgentProfile.last_name}`,
                id: selectedAgentProfile.id,
            });
        } else if (selectedPropertiesPopUP) {
            setSelectedOption({
                title: `${selectedPropertiesPopUP.first_name} ${selectedPropertiesPopUP.last_name}`,
                id: selectedPropertiesPopUP.id,
            });
        } else if (selectedRegion) {
            setSelectedOption({
                title: selectedRegion.title,
                id: selectedRegion.id,
            });
        } else {
            setSelectedOption(null);
        }
    }, [selectedAgentProfile, selectedPropertiesPopUP, selectedRegion]);

    const getUniqueAgentNames = (AssignAgentData, selectedAgentsCheckId, agents) => {
        // Ensure AssignAgentData and selectedAgentsCheckId are arrays to avoid errors
        const agentIds = AssignAgentData ? AssignAgentData.split(',') : [];
        const selectedIds = selectedAgentsCheckId ? selectedAgentsCheckId.split(',') : [];

        // Step 1: Filter unique IDs from AssignAgentData by checking against selectedAgentsCheckId
        const uniqueAgentIds = Array.from(new Set([...agentIds, ...selectedIds].filter(Boolean)));

        // Step 3: Map over unique IDs to get the name and last_name
        return uniqueAgentIds
            ?.map((id) => {
                const agent = agents?.find((agent) => agent.id === parseInt(id, 10)); // Parse id as integer
                return agent ? `${agent.name} ${agent.last_name}` : '';
            })
            .filter((name) => name);
    };
    const uniqueAgentNames = getUniqueAgentNames(AssignAgentData, selectedAgentsCheckId, agents);

    const filteredRegions = PreferredRegions?.filter((region) => region?.region_name.toLowerCase().includes(searchTerm));
    const filteredAgents = agents?.filter((agent) => agent?.name.toLowerCase().includes(searchTerm));
    const filteredProperties = properties?.filter((property) => property?.first_name.toLowerCase().includes(searchTerm));
    const combinedOptions = [
        ...filteredRegions.map((region) => ({
            id: region.id,
            title: region.region_name,
            firstLetter: 'REGIONS',
            lat: parseFloat(region.latitude),
            lng: parseFloat(region.longitude),
        })),
        ...filteredAgents.map((agent) => ({
            id: agent.id,
            title: `${agent.name} ${agent.last_name}`,
            firstLetter: 'AGENTS',
            lat: agent.latitude ? parseFloat(agent.latitude) : null,
            lng: agent.longitude ? parseFloat(agent.longitude) : null,
            name: agent.name,
            last_name: agent.last_name,
            quota: agent.quota,
            score: agent.score,
        })),
        ...filteredProperties.map((property) => ({
            id: property.id,
            title: `${property.first_name || ''} ${property.last_name || ''} 💵: ${property.buyer_max_price || ''}`,
            firstLetter: 'LEADS',
            lat: property.buyer_latitude ? parseFloat(property.buyer_latitude) : null,
            lng: property.buyer_longitude ? parseFloat(property.buyer_longitude) : null,
            first_name: property.first_name,
            last_name: property.last_name,
            display_address: property.display_address,
        })),
    ];

    const groupStyles = {
        REGIONS: {
            color: 'grey', // Dark blue text
        },
        AGENTS: {
            color: 'grey', // Dark green text
        },
        LEADS: {
            color: 'grey', // Dark red text
        },
    };

    const headerStyles = {
        REGIONS: {
            backgroundColor: 'grey',
            color: 'white',
            fontWeight: 'bold',
            borderRadius: '12px',
        },
        AGENTS: {
            backgroundColor: 'grey',
            color: 'white',
            fontWeight: 'bold',
            borderRadius: '12px',
        },
        LEADS: {
            backgroundColor: 'grey',
            color: 'white',
            fontWeight: 'bold',
            borderRadius: '12px',
        },
    };
    const handleRegionClick = (region) => {
        if (mapRef.current && region.lat && region.lng) {
            mapRef.current.panTo({
                lat: region.lat,
                lng: region.lng,
            });
            mapRef.current.setZoom(10); // Adjust zoom level as needed
        }
        setSelectedRegion(region);
        setSelectedAgentProfile(null);
        setSelectedPropertiesPopUP(null);
    };
    useEffect(() => {
        if (filterText) {
            const matchingGroups = new Set(
                combinedOptions.filter((option) => option.title.toLowerCase().includes(filterText.toLowerCase())).map((option) => option.firstLetter)
            );

            setOpenGroups((prev) => {
                const newGroups = { ...prev };
                let hasChanged = false;

                matchingGroups.forEach((group) => {
                    if (userToggles.hasOwnProperty(group)) {
                        newGroups[group] = userToggles[group];
                    } else if (!newGroups[group]) {
                        newGroups[group] = true;
                        hasChanged = true;
                    }
                });

                return hasChanged ? newGroups : prev;
            });
        }
    }, [filterText, combinedOptions, userToggles]);

    const toggleGroup = (group) => {
        setOpenGroups((prev) => ({ ...prev, [group]: !prev[group] }));
        setUserToggles((prev) => ({ ...prev, [group]: !prev[group] }));
    };
    useEffect(() => {
        if (!filterText) {
            setUserToggles({});
        }
    }, [filterText]);

    const handleInputChange = useCallback(
        debounce((e) => {
            setOpenGroups({
                AGENTS: false,
                LEADS: false,
                REGIONS: false,
            });
            setFilterText(e.target.value);
        }, 300),
        []
    );
    return isLoaded ? (
        <>
            <LinearProgress sx={{ visibility: loading || ModalOpenLoading ? '' : 'hidden' }} />
            <Paper elevation={4}>
                <div style={{ position: 'relative' }}>
                    <>
                        <div
                            style={{
                                position: 'absolute',
                                top: '20px',
                                left: '62px',
                                transform: 'translateX(-50%)',
                                zIndex: 10,
                                display: 'flex',
                                alignItems: 'center',
                                background: 'white',
                                borderRadius: '4px',
                                padding: '0px',
                            }}
                        ></div>

                        <div
                            style={{
                                position: 'absolute',
                                top: '30px',
                                left: '282px',
                                transform: 'translateX(-50%)',
                                zIndex: 10,
                                display: 'flex',
                                alignItems: 'center',
                                background: 'white',
                                borderRadius: '4px',
                                padding: '0px',
                            }}
                        >
                            {selectedDate && selectTime && (
                                <Button onClick={handleOpenSelectAgent} style={{ color: 'white', background: '#1976d2' }} fullWidth>
                                    List View
                                </Button>
                            )}
                        </div>

                        <div
                            style={{
                                position: 'absolute',
                                top: '20px',
                                left: '112px',
                                // right:'700px',
                                transform: 'translateX(-50%)',
                                zIndex: 10,
                                display: 'flex',
                                alignItems: 'center',
                                background: 'white',
                                borderRadius: '12px',
                                padding: '0px',
                            }}
                        >
                            <Box sx={{ width: ' auto' }}>
                                <Autocomplete
                                    options={combinedOptions.sort(customSort)}
                                    groupBy={(option) => option.firstLetter}
                                    getOptionLabel={(option) => option.title}
                                    isOptionEqualToValue={(option, value) => option.id === value.id}
                                    sx={{
                                        width: 200,
                                        '& .MuiOutlinedInput-root': {
                                            borderRadius: '12px',
                                        },
                                    }}
                                    renderInput={(params) => (
                                        <TextField {...params} label="Move to" variant="outlined" fullWidth onChange={handleInputChange} />
                                    )}
                                    renderOption={(props, option) => {
                                        const groupStyle = groupStyles[option.firstLetter];
                                        return (
                                            <MenuItem
                                                {...props}
                                                onClick={() => {
                                                    if (option.firstLetter === 'AGENTS') {
                                                        handleAgentProfileClick(option);
                                                        setSelectedRegion(null);
                                                        setSelectedPropertiesPopUP(null);
                                                    } else if (option.firstLetter === 'LEADS') {
                                                        handleMarkerClickProperties(option);
                                                        setSelectedAgentProfile(null);
                                                        setSelectedRegion(null);
                                                    } else if (option.firstLetter === 'REGIONS') {
                                                        handleRegionClick(option);
                                                        setSelectedAgentProfile(null);
                                                        setSelectedPropertiesPopUP(null);
                                                    }
                                                }}
                                                style={{ backgroundColor: groupStyle.backgroundColor, color: groupStyle.color }}
                                            >
                                                {option.title} {option.label}
                                            </MenuItem>
                                        );
                                    }}
                                    PaperComponent={(props) => <Box {...props} sx={{ maxHeight: 400, overflow: 'auto', background: 'white' }} />}
                                    renderGroup={(params) => (
                                        <Box key={params.key}>
                                            <Typography
                                                sx={{
                                                    backgroundColor: 'white',
                                                    fontWeight: headerStyles[params.group]?.fontWeight,
                                                    borderRadius: headerStyles[params.group]?.borderRadius,
                                                    padding: '8px',
                                                    position: 'sticky',
                                                    top: -10,
                                                    zIndex: 1,
                                                    cursor: 'pointer',
                                                    display: 'flex',
                                                    justifyContent: 'space-between',
                                                    alignItems: 'center',
                                                }}
                                                onClick={() => toggleGroup(params.group)}
                                            >
                                                {params.group}
                                                {openGroups[params.group] ? <ExpandLessIcon /> : <ExpandMoreIcon />}
                                            </Typography>
                                            {openGroups[params.group] && params.children}
                                        </Box>
                                    )}
                                    value={selectedOption}
                                    onChange={(_, value) => {
                                        setSelectedOption(value);
                                        if (value && mapRef.current && value.lat && value.lng) {
                                            mapRef.current.panTo({
                                                lat: value.lat,
                                                lng: value.lng,
                                            });
                                            mapRef.current.setZoom(value.firstLetter === 'REGIONS' ? 10 : 15);
                                        }
                                    }}
                                />
                            </Box>

                        </div>

                        <div
                            style={{
                                position: 'absolute',
                                top: '20px',
                                left: '50%',
                                transform: 'translateX(-50%)',
                                zIndex: 10,
                                display: 'flex',
                                alignItems: 'center',
                                background: 'white',
                                borderRadius: '4px',
                                padding: '0px',
                            }}
                        >
                            <Box>
                                <Autocomplete
                                    options={IcaMapStatus}
                                    getOptionLabel={(IcaMapStatus) => IcaMapStatus.label}
                                    value={IcaMapStatus?.find((option) => option.value === searchValue) || null}
                                    // renderOption={(props, option) => (
                                    //     <li {...props} style={{ color: colorMap[option.value] || 'black' }}>
                                    //         {option.label}
                                    //     </li>
                                    // )}
                                    renderInput={(params) => (
                                        <TextField
                                            {...params}
                                            label="Select status"
                                            InputProps={{
                                                ...params.InputProps,
                                                style: { color: selectedColor, fontWeight: 'bold' },
                                            }}
                                            InputLabelProps={{
                                                ...params.InputLabelProps,
                                                style: { color: selectedColor, fontWeight: 'bold' },
                                            }}
                                        />
                                    )}
                                    // onChange={(event, newValue) => {
                                    //     setSearchValue(newValue ? newValue?.value : '');
                                    //     setMapCenter({ lat: 34.052235, lng: -118.243683 });
                                    //     setSelectedOption(null);
                                    //     setAgents([]);
                                    //     setProperties([])
                                    //     setZoom(10);
                                    //     if (mapRef.current) {
                                    //         mapRef.current.panTo({ lat: 34.052235, lng: -118.243683 });
                                    //         mapRef.current.setZoom(10);
                                    //     }
                                    // }}
                                    onChange={(event, newValue) => handleMoveToFilter(event, newValue)}
                                    sx={{
                                        width: 320,
                                        '& .MuiOutlinedInput-root': {
                                            borderRadius: '12px',
                                        },
                                    }}
                                />
                            </Box>
                        </div>

                        <div
                            style={{
                                position: 'absolute',
                                top: '15px',
                                left: '93%',
                                transform: 'translateX(-50%)',
                                zIndex: 10,
                                display: 'flex',
                                alignItems: 'center',
                                borderRadius: '4px',
                                padding: '5px',
                            }}
                        >
                            <Box style={{ display: 'flex', justifyContent: 'flex-end' }}>
                                <InviteAgent
                                    AssignAgentData={AssignAgentData}
                                    properties={properties}
                                    AssignUser={AssignUser}
                                    AllAgentsData={AllAgentsData}
                                    open={open}
                                    selectedPropertyId={selectedPropertyId}
                                    selectedDate={selectedDate}
                                    selectTime={selectTime}
                                    googleLocation={googleLocation}
                                    latitude={latitude}
                                    longitude={longitude}
                                    handleClose={handleClose}
                                    AllAgentsLeadData={AllAgentsLeadData}
                                    setOpen={setOpen}
                                    getLeads={getLeads}
                                    searchValue={searchValue}
                                />
                            </Box>
                        </div>
                        {uniqueAgentNames?.length > 0 && (
                            <div
                                style={{
                                    position: 'absolute',
                                    top: '90%',
                                    left: '112px',
                                    transform: 'translateX(-50%)',
                                    zIndex: 10,
                                    display: 'flex',
                                    alignItems: 'center',
                                    borderRadius: '8px',
                                    padding: '8px 16px',
                                }}
                            >
                                <Box sx={{ width: 'auto' }}>
                                    <Button
                                        onClick={handleAgentViewOpen}
                                        variant="contained"
                                        sx={{
                                            borderRadius: '12px',
                                            padding: '8px 16px',
                                            fontWeight: 'bold',
                                            textTransform: 'capitalize',
                                        }}
                                    >
                                        Selected Agents List
                                    </Button>
                                    <Dialog
                                        open={openAgentView}
                                        onClose={handleAgentViewClose}
                                        style={{ borderRadius: '22px', boxShadow: '0 4px 20px rgba(0, 0, 0, 0.2)' }}
                                    >
                                        <DialogTitle>
                                            <Box
                                                style={{
                                                    display: 'flex',
                                                    alignItems: 'center',
                                                    justifyContent: 'space-between',
                                                    padding: '8px 12px',
                                                    borderBottom: '1px solid #f0f0f0',
                                                }}
                                            >
                                                <div
                                                    style={{
                                                        display: 'flex',
                                                        alignItems: 'center',
                                                        padding: '6px 12px',
                                                        borderRadius: '8px',
                                                    }}
                                                >
                                                    <Typography
                                                        style={{
                                                            color: 'black',
                                                            fontSize: '16px',
                                                            fontWeight: '500',
                                                        }}
                                                    >
                                                        Selected Agents
                                                    </Typography>
                                                </div>
                                                <IconButton
                                                    onClick={handleAgentViewClose}
                                                    style={{
                                                        color: '#9e9e9e',
                                                    }}
                                                >
                                                    <CloseIcon />
                                                </IconButton>
                                            </Box>
                                        </DialogTitle>
                                        <div
                                            style={{
                                                maxHeight: '400px',
                                                overflowY: 'auto',
                                                width: '300px',
                                                padding: '8px 16px',
                                                background: '#f9f9f9',
                                                borderRadius: '0 0 8px 8px',
                                            }}
                                        >
                                            <List>
                                                {uniqueAgentNames?.map((fullName, index) => (
                                                    <ListItem
                                                        key={index}
                                                        style={{
                                                            display: 'flex',
                                                            alignItems: 'center',
                                                            padding: '8px 12px',
                                                            borderBottom: '1px solid #e0e0e0',
                                                        }}
                                                    >
                                                        <Avatar
                                                            sx={{
                                                                bgcolor: '#607D8B',
                                                                color: 'white',
                                                                marginRight: '12px',
                                                            }}
                                                        >
                                                            {fullName[0].toUpperCase()}
                                                        </Avatar>
                                                        <ListItemText primary={fullName} />
                                                    </ListItem>
                                                ))}
                                            </List>
                                        </div>
                                    </Dialog>
                                </Box>
                            </div>
                        )}

                        <div className={classes.mapInviteButtonStyle}>
                            <Box style={{ display: 'flex', justifyContent: 'flex-end' }}>
                                {selectedDate && selectTime && (
                                    <Button
                                        style={{ width: '190px', padding: '10px', backgroundColor: '#a8a8a8', color: 'white', marginRight: '20px' }}
                                        onClick={() => {
                                            // Convert `selectedAgentsCheckId` and `AssignAgentData` to arrays and filter out duplicates
                                            const selectedAgentsArray = selectedAgentsCheckId.split(',');
                                            const assignAgentsArray = AssignAgentData.split(',');
                                            // Combine arrays and filter out duplicates by converting to a Set
                                            const agentIdToSendArray = Array.from(
                                                new Set([...selectedAgentsArray, ...assignAgentsArray].filter(Boolean))
                                            );
                                            // Convert back to a comma-separated string
                                            const agentIdToSend = agentIdToSendArray.join(',');

                                            AssignUser(
                                                agentIdToSend, // Send the resolved unique agent IDs as a string
                                                selectedPropertyId,
                                                selectedDate,
                                                selectTime,
                                                googleLocation,
                                                latitude,
                                                longitude
                                            );
                                        }}
                                    >
                                        Send Invite By Agents
                                    </Button>
                                )}
                            </Box>
                        </div>
                        <div className={classes.mapReloadButtonStyle}>
                            <Box onClick={HandleRestValue}>
                                <Avatar
                                    sx={{
                                        cursor: 'pointer',
                                        bgcolor: '#5c7dbd',
                                        width: 40,
                                        height: 40,
                                    }}
                                >
                                    <CachedIcon />
                                </Avatar>
                            </Box>
                        </div>

                        <GoogleMap
                            options={{
                                disableDefaultUI: false,
                                clickableIcons: true,
                                scrollwheel: true,
                                mapTypeControl: false,
                                fullscreenControl: false,
                                streetViewControl: false,
                                minZoom: 7,
                            }}
                            mapContainerStyle={containerStyle}
                            center={mapCenter}
                            onLoad={(map) => {
                                mapRef.current = map;
                            }}
                            zoom={zoom}
                        >
                            {/* Properties */}
                            {properties?.length === 1
                                ? // If properties.length is equal to 1, render markers
                                properties?.map((property) => (
                                    <Marker
                                        key={property.id}
                                        position={{
                                            lat: parseFloat(property?.buyer_latitude),
                                            lng: parseFloat(property?.buyer_longitude),
                                        }}
                                        onClick={(event) => handleMarkerClickProperties(property, event)}
                                        icon={{
                                            url: 'assets/Convrt_bg_blue.png',
                                            scaledSize: new window.google.maps.Size(40, 40),
                                        }}
                                    />
                                ))
                                : properties?.map((property) => {
                                    const { formattedStatusShow, divStyle } = mapStatusToFormatAndColorShow(property?.status);
                                    // If properties.length is not equal to 1, render markers with another type of icon
                                    return (
                                        <React.Fragment key={property.id}>
                                            <style>
                                                {`
                                                            /* Custom styles for InfoWindow close button */
                                                            .gm-ui-hover-effect {
                                                                width: 45px !important;
                                                                height: 24px !important;
                                                            }
                                                            .gm-ui-hover-effect > img {
                                                                width: 100%;
                                                                height: 100%;
                                                                
                                                            }
                                                            `}
                                            </style>
                                            <Marker
                                                key={property.id}
                                                position={{
                                                    lat: parseFloat(property?.buyer_latitude),
                                                    lng: parseFloat(property?.buyer_longitude),
                                                }}
                                                onClick={() => handleMarkerClickProperties(property)}
                                                icon={{
                                                    url: 'assets/Convrt_bg_remover.png',
                                                    scaledSize: new window.google.maps.Size(40, 40),
                                                }}
                                            >
                                                {/* Conditionally Render the InfoWindow */}
                                                {selectedPropertiesPopUP?.id === property.id && (
                                                    <InfoWindow
                                                        position={{
                                                            lat: parseFloat(property.buyer_latitude),
                                                            lng: parseFloat(property.buyer_longitude),
                                                        }}
                                                        onCloseClick={() => setSelectedPropertiesPopUP(null)}
                                                        options={{
                                                            pixelOffset: new window.google.maps.Size(1, -2), // Adjust this value if necessary
                                                        }}
                                                    >
                                                        <div>
                                                            <Box sx={{ display: 'flex', alignItems: 'center' }}>
                                                                <Avatar
                                                                    src={
                                                                        selectedPropertiesPopUP?.profile_image
                                                                            ? `https://iconnctapp.com/${selectedPropertiesPopUP?.profile_image}`
                                                                            : 'assets/Convrt_bg_remover.png'
                                                                    }
                                                                    sx={{ width: 50, height: 50, marginRight: '16px' }}
                                                                />
                                                                <Box>
                                                                    <Typography style={{ fontSize: '12px', fontWeight: 'bold' }}>
                                                                        {selectedPropertiesPopUP?.first_name} {selectedPropertiesPopUP?.last_name}
                                                                    </Typography>
                                                                    <div style={{ marginBottom: '2px' }}>
                                                                        <span
                                                                            style={{
                                                                                ...divStyle,
                                                                                borderRadius: '10px',
                                                                                padding: '1px',
                                                                                fontSize: '10px',
                                                                            }}
                                                                        >
                                                                            {formattedStatusShow}
                                                                        </span>
                                                                    </div>
                                                                    {/* <Typography style={{ fontSize: '10px', color: 'grey' }}>
                                                                        📧: {selectedPropertiesPopUP?.email}
                                                                    </Typography> */}
                                                                    <Typography style={{ fontSize: '10px', color: 'grey', width: '200px' }}>
                                                                        📊: {selectedPropertiesPopUP?.display_address}
                                                                    </Typography>
                                                                </Box>
                                                            </Box>
                                                            {/* Profile Button */}
                                                            <Box style={{ marginTop: '20px' }}>
                                                                <Button
                                                                    variant="outlined"
                                                                    color="success"
                                                                    size="small"
                                                                    onClick={() => handleProfileClick(selectedPropertiesPopUP)}
                                                                    style={{
                                                                        position: 'absolute',
                                                                        bottom: '10px',
                                                                        right: '10px',
                                                                        fontSize: '8px',
                                                                    }}
                                                                >
                                                                    Profile
                                                                </Button>
                                                            </Box>
                                                        </div>
                                                    </InfoWindow>
                                                )}
                                            </Marker>
                                        </React.Fragment>
                                    );
                                })}

                            {selectedProperties && (
                                <CustomerLeadProfile
                                    selectedProperties={selectedProperties}
                                    handleAssignLead={handleAssignLead}
                                    handleRequestedAgents={handleRequestedAgents}
                                    getLeads={getLeads}
                                    searchValue={searchValue}
                                    setSelectedProperties={setSelectedProperties}
                                    selectedTags={selectedTags}
                                    setSelectedTags={setSelectedTags}
                                    tags={tags}
                                    setTags={setTags}
                                    stopGetLeads={stopGetLeads}
                                />
                            )}
                            {/* Agents */}
                            {/* {agents?.map((agent) => (
                            <Marker
                                title={`${agent?.name} ${agent?.last_name}`}
                                key={agent.id}
                                position={{ lat: parseFloat(agent.latitude), lng: parseFloat(agent.longitude) }}
                                onClick={() => handleMarkerClick(agent)}
                                icon={{
                                    url: AssignAgentData.includes(agent.id.toString()) ? '/assets/man-avatar.png' : '/assets/BlackAgent.png', // Use different icon if agent id is in AssignAgentData
                                    scaledSize: new window.google.maps.Size(40, 40),
                                    fillColor: properties?.length == 1 ? '#4f9109' : null, 
                                    fillOpacity: 1,
                                }}
                            >
                            </Marker>
                        ))} */}

                            {/* New Code */}

                            {agents?.map((agent) => {
                                // Check if lat and lng are valid and exist
                                if (agent?.latitude && agent?.longitude) {
                                    // Concatenate the profile image with the base URL
                                    const profileImageUrl = agent?.profile_image
                                        ? `https://iconnctapp.com/${agent?.profile_image}`
                                        : '/public/assets/BlackAgent.png'; // Default avatar path

                                    return (
                                        <React.Fragment key={agent?.id}>
                                            <style>
                                                {`
                                                            /* Custom styles for InfoWindow close button */
                                                            .gm-ui-hover-effect {
                                                                width: 45px !important;
                                                                height: 24px !important;
                                                            }
                                                            .gm-ui-hover-effect > img {
                                                                width: 100%;
                                                                height: 100%;
                                                                
                                                            }
                                                            `}
                                            </style>
                                            <OverlayView
                                                key={agent?.id}
                                                position={{ lat: parseFloat(agent?.latitude), lng: parseFloat(agent?.longitude) }}
                                                mapPaneName={OverlayView.OVERLAY_MOUSE_TARGET}
                                            >
                                                <div
                                                    style={{
                                                        position: 'relative',
                                                        display: 'inline-block',
                                                        textAlign: 'center',
                                                    }}
                                                >
                                                    {/* Custom marker with rounded image */}
                                                    <div
                                                        style={{
                                                            borderRadius: '50%',
                                                            overflow: 'hidden',
                                                            border: '2px solid white',
                                                            cursor: 'pointer',
                                                            backgroundColor: '#fff',
                                                            width:
                                                                agent?.subscription_type === 'founder'
                                                                    ? 40
                                                                    : agent?.subscription_type === 'premier'
                                                                        ? 60
                                                                        : agent?.subscription_type === 'elite'
                                                                            ? 80
                                                                            : 30,
                                                            height:
                                                                agent?.subscription_type === 'founder'
                                                                    ? 40
                                                                    : agent?.subscription_type === 'premier'
                                                                        ? 60
                                                                        : agent?.subscription_type === 'elite'
                                                                            ? 80
                                                                            : 30,
                                                        }}
                                                        title={`${agent?.name} ${agent?.last_name}`} // Tooltip on hover
                                                    >
                                                        <Avatar
                                                            style={{
                                                                width: '100%',
                                                                height: '100%',
                                                                objectFit: 'cover',
                                                                borderRadius: '50%', // Rounds the image
                                                            }}
                                                            onClick={(event) => {
                                                                event.stopPropagation(); // Prevent the marker click from firing
                                                                handleAgentProfileClick(agent);
                                                            }}
                                                            src={profileImageUrl}
                                                            sx={{ width: 60, height: 60, marginRight: '16px' }}
                                                        />
                                                    </div>

                                                    <div>
                                                        {selectedAgentProfile?.id === agent?.id && (
                                                            <InfoWindow
                                                                position={{ lat: parseFloat(agent?.latitude), lng: parseFloat(agent?.longitude) }}
                                                                onCloseClick={() => setSelectedAgentProfile(null)}
                                                                options={{
                                                                    pixelOffset: new window.google.maps.Size(28, -3), // Adjust this value
                                                                }}
                                                            >
                                                                <div>
                                                                    <Box
                                                                        sx={{
                                                                            display: 'flex',
                                                                            alignItems: 'center',
                                                                        }}
                                                                    >
                                                                        <Avatar
                                                                            src={
                                                                                selectedAgentProfile?.profile_image
                                                                                    ? `https://iconnctapp.com/${selectedAgentProfile?.profile_image}`
                                                                                    : '/public/assets/BlackAgent.png'
                                                                            }
                                                                            alt={selectedAgentProfile?.name}
                                                                            sx={{ width: 60, height: 60, marginRight: '16px' }}
                                                                        />
                                                                        <Box>
                                                                            <Typography style={{ fontSize: '12px', fontWeight: 'bold' }}>
                                                                                {selectedAgentProfile?.name} {selectedAgentProfile?.last_name}
                                                                            </Typography>
                                                                            {/* <Typography style={{ fontSize: '10px', color: 'grey' }}>
                                                                                📧: {selectedAgentProfile?.email}
                                                                            </Typography> */}
                                                                            <Typography style={{ fontSize: '10px', color: 'grey' }}>
                                                                                Score: 🎯 {selectedAgentProfile?.score}
                                                                            </Typography>
                                                                            <Typography style={{ fontSize: '10px', color: 'grey' }}>
                                                                                Quota:📊 {selectedAgentProfile?.quota}
                                                                            </Typography>
                                                                        </Box>
                                                                    </Box>
                                                                    {/* Profile Button */}
                                                                    {properties?.length === 1 && selectedDate && selectTime ? (
                                                                        <Box style={{ marginTop: '15px' }}>
                                                                            <Button
                                                                                variant="outlined"
                                                                                color={selectedAgents[agent.id] ? 'error' : 'success'} // Change color based on state
                                                                                size="small"
                                                                                onClick={() => handleMarkerClick(agent)}
                                                                                style={{
                                                                                    position: 'absolute',
                                                                                    bottom: '10px',
                                                                                    right: '10px',
                                                                                    fontSize: '8px',
                                                                                }}
                                                                            >
                                                                                {selectedAgents[agent.id] ? 'Unselect' : 'Select'}{' '}
                                                                                {/* Toggle button text */}
                                                                            </Button>
                                                                        </Box>
                                                                    ) : (
                                                                        <Box style={{ marginTop: '15px' }}>
                                                                            <Button
                                                                                variant="outlined"
                                                                                color="success"
                                                                                size="small"
                                                                                onClick={() => handleMarkerClick(agent)}
                                                                                style={{
                                                                                    position: 'absolute',
                                                                                    bottom: '10px',
                                                                                    right: '10px',
                                                                                    fontSize: '8px',
                                                                                }}
                                                                            >
                                                                                Profile
                                                                            </Button>
                                                                        </Box>
                                                                    )}
                                                                </div>
                                                            </InfoWindow>
                                                        )}
                                                    </div>
                                                </div>
                                            </OverlayView>
                                        </React.Fragment>
                                    );
                                } else {
                                    return null;
                                }
                            })}

                            {selectedAgent && properties?.length !== 1 && (
                                <AgentProfile
                                    selectedAgent={selectedAgent}
                                    properties={properties}
                                    getLeads={getLeads}
                                    setSelectedAgent={setSelectedAgent}
                                    handleAssignLead={handleAssignLead}
                                    searchValue={searchValue}
                                />
                            )}
                        </GoogleMap>
                    </>
                    {/* InviteModal */}

                    {/* tokenExpireLogoutModal */}

                    <Dialog
                        open={OpenSelectAgent}
                        TransitionComponent={Transition}
                        sx={{
                            '& .MuiDialog-paper': {
                                minWidth: '680px',
                                borderRadius: '22px',
                                boxShadow: '0 4px 20px rgba(0, 0, 0, 0.2)',
                            },
                        }}
                    >
                        <DialogTitle>
                            <IconButton style={{ position: 'absolute', top: '10px', right: '10px' }} onClick={handleCloseSelectAgent}>
                                <CloseIcon />
                            </IconButton>
                            <Box
                                sx={{
                                    p: '10px',
                                    display: 'flex',
                                    alignItems: 'center',
                                    background: '#F0F4F8',
                                    borderRadius: '10px',
                                    marginTop: '30px',
                                }}
                            >
                                <IconButton type="button" sx={{ p: '10px' }} aria-label="search">
                                    <SearchIcon />
                                </IconButton>
                                <InputBase
                                    sx={{ ml: 1, flex: 1 }}
                                    value={searchTermAgent}
                                    onChange={(e) => setSearchTermAgent(e.target.value)}
                                    placeholder="Search..."
                                    inputProps={{ 'aria-label': 'search google maps' }}
                                />
                            </Box>
                            {filteredAgentsChecked?.length > 0 && (
                                <Box style={{ display: 'flex', justifyContent: 'flex-end', marginTop: '10px' }}>
                                    <Button onClick={handleSelectAll}>
                                        {selectedAgentsCheckId.split(',').length === agents?.length ? 'Unselect All' : 'Select All'}
                                    </Button>
                                </Box>
                            )}
                        </DialogTitle>

                        <DialogContent>
                            {filteredAgentsChecked?.length === 0 ? (
                                <div style={{ display: 'flex', justifyContent: 'center' }}>
                                    <Typography variant="h6" style={{ marginTop: '20px' }}>
                                        No data found
                                    </Typography>
                                </div>
                            ) : (
                                filteredAgentsChecked.map((agent) => (
                                    <Card
                                        key={agent.id}
                                        style={{
                                            padding: '20px',
                                            marginTop: '20px',
                                            borderRadius: '12px',
                                            boxShadow: '0 2px 10px rgba(0, 0, 0, 0.1)',
                                        }}
                                    >
                                        <Grid container spacing={2} alignItems="center">
                                            <Grid item xs={2} sm={2} md={2} lg={2}>
                                                <Avatar
                                                    style={{ width: '70px', height: '70px' }}
                                                    src={`https://iconnctapp.com/${agent?.profile_image}`}
                                                />
                                            </Grid>
                                            <Grid item xs={8} sm={8} md={8} lg={8}>
                                                <Typography style={{ fontWeight: 'bold', fontSize: '19px' }}>
                                                    {agent?.name} {agent?.last_name}
                                                </Typography>
                                                <Box style={{ display: 'flex' }}>
                                                    <Typography>🎯 : {agent?.quota}</Typography>
                                                    <Typography style={{ marginLeft: '12px' }}>🚖 : {agent?.distance?.toFixed(2)}km</Typography>
                                                </Box>
                                                <Typography>📊 : {agent?.score}</Typography>
                                            </Grid>
                                            <Grid item xs={2} sm={2} md={2} lg={2}>
                                                <Box display="flex" justifyContent="flex-end">
                                                    <Checkbox
                                                        checked={selectedAgentsCheckId.split(',').includes(agent?.id.toString())}
                                                        onChange={() => handleCheckboxChange(agent?.id)}
                                                    />
                                                </Box>
                                            </Grid>
                                        </Grid>
                                    </Card>
                                ))
                            )}
                        </DialogContent>
                        <DialogActions style={{ justifyContent: 'center' }}>
                            <Button
                                onClick={handleDoneSelectAgent}
                                style={{
                                    width: '250px',
                                    padding: '10px',
                                    backgroundColor: '#1976d2',
                                    color: 'white',
                                    borderRadius: '12px',
                                    transition: 'background-color 0.3s',
                                }}
                                onMouseOver={(e) => (e.currentTarget.style.backgroundColor = '#155A8A')}
                                onMouseOut={(e) => (e.currentTarget.style.backgroundColor = '#1976d2')}
                            >
                                Done
                            </Button>
                        </DialogActions>
                    </Dialog>
                    <LogoutExpiredModal setLogOutModal={setLogOutModal} logOutModal={logOutModal} />
                </div>
            </Paper>
        </>
    ) : (
        <></>
    );
}

export default React.memo(MyComponent);
